export const SYBERRY_TODAY_API_ENDPOINTS = {
  today: '/syberry-today',
  issueCategory: (issueId: string) => `/issues/personal-backlog/${issueId}/category`,
  personalBacklogOrder: '/issues/personal-backlog/order',
  queueIssueOrder: (queueId: number) => `/queues/${queueId}/issues/order`,
  confirmCheckin: '/syberry-today/checkin/confirm',
  skipCheckin: '/syberry-today/checkin/skip',
  postponeCheckin: '/syberry-today/checkin/postpone',
  issueTimeEntries: (issueId: string) => `/issues/${issueId}/time-entries`,
};

export const SYBERRY_TODAY_ALLOCATION_API_ENDPOINTS = {
  currentWeekAllocation: (employeeAlias: string) =>
    `/employees/${encodeURIComponent(employeeAlias)}/current-week-allocation`,
};

export const SYBERRY_TODAY_API_ENDPOINT_PATTERNS = {
  issueCategory: /^\/issues\/personal-backlog\/([^/]+)\/category$/,
  queueIssueOrder: /^\/queues\/(\d+)\/issues\/order$/,
  issueTimeEntries: /^\/issues\/([^/]+)\/time-entries$/,
};
